<template>
  <transition
    :appear="appear"
    enter-active-class="transition"
    enter-from-class="opacity-0 scale-90"
    leave-active-class="transition"
    leave-to-class="opacity-0 scale-90"
    :mode="mode"
  >
    <slot />
  </transition>
</template>

<script lang="ts" setup>
import type { TransitionProps } from "vue";

defineProps<{
  appear?: boolean;
  mode?: TransitionProps["mode"];
}>();
</script>
